import { initializeApp, getApps, getApp } from "firebase/app";
import type { FirebaseApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app: FirebaseApp;

if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

const auth = getAuth(app);

// Connect to Auth emulator ONLY in dev builds.
// IMPORTANT: Never connect in production builds, even if the env var is accidentally set,
// otherwise Firebase Auth will route sign-in to the emulator (e.g. http://localhost:9099).
if (typeof window !== "undefined") {
  const authEmulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  // Allow emulator usage on localhost even for preview/debug builds.
  // Never connect on real production domains.
  const shouldUseAuthEmulator = Boolean(authEmulatorHost && isLocalhost);

  if (shouldUseAuthEmulator) {
    try {
      connectAuthEmulator(auth, `http://${authEmulatorHost}`, {
        disableWarnings: true,
      });
    } catch {
      // Emulator already connected, ignore
    }
  } else if (authEmulatorHost && !isLocalhost) {
    // This is a misconfiguration we want to notice quickly.
    console.warn(
      "[Firebase] VITE_FIREBASE_AUTH_EMULATOR_HOST is set, but this is a production build. " +
        "Ignoring it to prevent auth redirects to the local emulator."
    );
  }
}

export { app, auth };
